import api from '../api/axios';
import { decryptData } from '../utils/decrypt';

export const getCardStats = async () => {
    try {
        const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/dashboard/get-card-stats`);


               const decrypted = decryptData(response.data, response.data.iv);
             
             return decrypted;
        // return response.data;
    } catch (error) {
        console.error('Error fetching dashboard data:', error);
        throw error;
    }
};


export const getVisitsPerMonth = async (params: {
    rangeType: string;
    fromDate?: string;
    toDate?: string;
}) => {
    const response = await api.get(
        `${import.meta.env.VITE_API_BASE_URL}/dashboard/visits-per-month`,
        { params }
    );
     
         const decrypted = decryptData(response.data, response.data.iv);
             
             return decrypted;


    // return response.data;
};

export const getMeetingTimePerMonth = async (params: {
    rangeType: string;
    fromDate?: string;
    toDate?: string;
}) => {
    const response = await api.get(
        `${import.meta.env.VITE_API_BASE_URL}/dashboard/visit-hours-per-month`,
        { params }
    );

      const decrypted = decryptData(response.data, response.data.iv);
             
      return decrypted;

    // return response.data;
};

export const getStatusBreakdownPerPeriod = async (params: {
    rangeType: string;
    fromDate?: string;
    toDate?: string;
}) => {
    const response = await api.get(
        `${import.meta.env.VITE_API_BASE_URL}/dashboard/get-status-breakdown-per-period`,
        { params }
    );

    const decrypted = decryptData(response.data, response.data.iv);
             
      return decrypted;

    // return response.data;
};


export const getMeetingsByAgenda = async () => {
    const response = await api.get(
        `${import.meta.env.VITE_API_BASE_URL}/dashboard/get-meetings-by-agenda`

    );

     const decrypted = decryptData(response.data, response.data.iv);
             
     return decrypted;
    // return response.data;
};
